import React from 'react';
import { LocationWithContactDto } from '@apiModels/LocationWithContactDto.csharp';

import { useInsuranceFilters } from '../Utils/Context/filtersContext';
import { useInsuranceLabels } from '../Utils/Context/labelsContext';

import { LocationsCards } from './LocationsCards';
import { LocationsCombobox } from './LocationsCombobox';

interface LocationsContactInfoProps<T> {
  locations: T[];
  displayDropDown?: boolean
}

export const LocationsContactInfo = <T extends LocationWithContactDto>(
  props: LocationsContactInfoProps<T>
) => {
  const { locations, displayDropDown = true } = props;

  const { locations: selectedLocations } = useInsuranceFilters();

  const {
    headings
  } = useInsuranceLabels();

  const hasSelectedLocations = selectedLocations && selectedLocations.length !== 0;

  return (
    <div className="locationsContactInfo">
      {(displayDropDown || hasSelectedLocations) && (
        <h3 className="locationsContactInfo__header">
          {headings.ourCentersHeading}
        </h3>
      )}
      {displayDropDown && (
        <LocationsCombobox
          locations={locations}
          className="locationsContactInfo__combobox"
        />
      )}
      {selectedLocations && selectedLocations.length !== 0 && (
        <LocationsCards
          selectedLocations={selectedLocations as LocationWithContactDto[]}
        />
      )}
    </div>
  )
};
